module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_cart":"Update cart","remove_item":"Remove item"}}')
  delete Component.options._Ctor
}
